import { FC } from "react";
import { useTranslation } from "react-i18next";
import { getInstagramFollowersDefinitionInfo } from "../OrganicMediaDefinitions";
import InstagramRankedFollowersPanel, {
  type InstagramFollowersGeoRow,
} from "./InstagramRankedFollowersPanel";
import "../../../styles/InstagramFollowersReport/InstagramFollowersByCity.scss";

type InstagramFollowersByCityProps = {
  rows: InstagramFollowersGeoRow[];
  value: number;
  max: number;
  onChange: (_value: number) => void;
};

const InstagramFollowersByCity: FC<InstagramFollowersByCityProps> = ({
  rows,
  value,
  max,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <InstagramRankedFollowersPanel
      title={t("organicMedia.followers.totalByCity")}
      tooltipInfo={getInstagramFollowersDefinitionInfo("Total Followers by City", undefined, t)}
      topLabel={t("organicMedia.followers.topCitiesLabel")}
      rows={rows}
      value={value}
      disabled={rows.length === 0}
      onChange={next => {
        const n = Math.max(1, Math.min(max, next));
        onChange(n);
      }}
      formulaTitle={t("organicMedia.common.formula")}
      emptyLabel={t("webAnalytics.noData")}
    />
  );
};

export default InstagramFollowersByCity;
